import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { InventoryOpdgElementByBrandContainerModel } from '../../../../../models/aggregates/inventory-opdg-element-by-brand-hdr';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class InventoryOpdgElementByBrandHdrService extends BaseApiPublicLoginTemplateService<InventoryOpdgElementByBrandContainerModel,InventoryOpdgElementByBrandContainerModel,InventoryOpdgElementByBrandContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'opdg-element-by-brand-hdrs/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'opdg-element-by-brand-hdrs/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  public deleteBrandCorners(opdgElementGuid, visa: ApiVisa) {
    this.apiUrl = visa.api_domain_url+ this.endpoint_path + '/opdgElement/' + opdgElementGuid;
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(visa))
  }
}